export default __webpack_public_path__ + "static/media/option-2.48ab78c6.svg";